import Logo from "../svgs/logo";
import React from "react";
import { motion } from "framer-motion";

const WordExpander = () => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <motion.div
      className="flex items-center  cursor-pointer w-auto pr-0"
      onHoverStart={() => setHovered(true)}
      onHoverEnd={() => setHovered(false)}
    >
      {/* Logo (Always visible) */}
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: hovered ? 0 : 1 }}
        transition={{ duration: 0.2 }}
      >
        <Logo light />
      </motion.div>

      {/* "NPS" Text (Fades in on hover) */}
      <motion.span
        className="font-bold text-lg"
        initial={{ opacity: 0 }}
        animate={{
          opacity: hovered ? 1 : 0,
          x: hovered ? -30 : 0,
        }}
        transition={{ duration: 0.2 }}
      >
        NordicPosterStore
      </motion.span>
    </motion.div>
  );
};

export default WordExpander;
